'use client';
import Image from 'next/image';
import { useState } from 'react';
import { useMessageStore } from '@/helpers/top_message';
import { useSizeModal } from '@/helpers/size_guide_modal';

const Topbar = ({ top_text }: { top_text: string }) => {
  const [showTop, setShowTop] = useState(true);
  const { toggleMessage } = useMessageStore();
  const { isSizeModalOpen } = useSizeModal();
  return (
    <div
      id="topbar"
      className={`${
        showTop ? 'flex' : 'hidden'
      } ${isSizeModalOpen ? 'z-0' : 'z-[60]'} relative justify-center items-center w-full bg-black px-5 pt-2 pb-1 md:py-3 text-xs lg:text-sm text-white text-center`}
    >
      <p className="font-medium md:font-normal">{top_text}</p>
      <Image
        src={'/icons/close.svg'}
        alt=""
        width={20}
        height={20}
        className="absolute w-3 h-3 right-2 md:right-10 invert cursor-pointer"
        onClick={() => {
          setShowTop(false);
          toggleMessage(false);
        }}
      />
    </div>
  );
};

export default Topbar;
